/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import LogoWhite from 'ui/assets/envio-white.png';
import OnboardingMenu from '../menu/onboarding.menu';

const HeaderVertical = () => {
  return (
    <div className="bg-dark" style={{ minHeight: '100vh' }}>
      <div className="navbar-brand mb-3 mb-md-5 p-md-4 px-3 py-4">
        <img
          //   src={client?.logo || LogoWhite}
          src={LogoWhite}
          alt=""
          className="img-fluid"
          style={{ maxHeight: 40 }}
          id="logo-operator"
        />
      </div>

      <OnboardingMenu />
    </div>
  );
};

export default HeaderVertical;
